import React from 'react'

export default function IDVideo({ data }) {
  return (
    <>
      <section className="integration-video" id="watch-video">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="video-text">
                <h4 className="heading">{data?.video_title}</h4>
                <p>{data?.video_subtitle}</p>
              </div>
            </div>
            <div className="col-md-12 col-lg-12">
              <div className="iframe-video">
                <iframe width="560" height="315" src={data?.last_video_url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
